module.exports = __webpack_public_path__ + "img/36.c4652f26.jpg";